import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { Dietitian } from '../../../../data/dietitian/domain/dietitian';
import { PatientGroup } from '../../../../data/dietitian/domain/patient_group/patient_group';
import { PatientGroupCommands } from '../../../../data/dietitian/domain/patient_group/patient_group_commands';
import { Patient } from '../../../../data/patient/domain/patient';
import { PatientCommands } from '../../../../data/patient/domain/patient_commands';
import { SortListType } from '../../routes/questions/questions.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-patient-selector',
  templateUrl: './patient-selector.component.html',
  styleUrls: ['./patient-selector.component.scss'],
})
export class PatientSelectorComponent implements OnInit {
  @Input() public dietitian: Dietitian | undefined;
  @Output() onSelect = new EventEmitter<Patient>();
  @Output() onCancel = new EventEmitter<void>();

  public patientsList: Patient[] = [];
  public totalResults = 0;
  public isLoading = false;
  public isAppendLoading = false;
  public patientPerformingAction?: string;
  public isOnError = false;
  public currentPage = 0;
  public currentPaginationIndex = 0;
  public itemsPerPage = 30;

  private currentSearchQuery: string | undefined;
  private groups: PatientGroup[];

  constructor(
    private bsModalRef: BsModalRef,
    private patientCommands: PatientCommands,
    private patientGroupCommands: PatientGroupCommands,
  ) {
    // NaDa
  }

  ngOnInit(): void {
    this.loadPatients(0);
    if (this.dietitian) {
      this.patientGroupCommands
        .getDietitianPatientGroups(this.dietitian.id.toString())
        .then((g) => (this.groups = g));
    }
  }

  updateSearchQuery(query?: string) {
    this.currentSearchQuery = query;

    if (this.currentPaginationIndex > 1) {
      this.currentPaginationIndex = 1;
    }

    this.loadPage(0);
  }

  loadPage(index: number) {
    this.loadPatients(index);
  }

  loadPatients(page: number) {
    if (!this.dietitian) {
      return;
    }
    if (page === 0) {
      this.isLoading = true;
      this.patientsList = [];
    } else {
      this.isAppendLoading = true;
    }
    this.isOnError = false;
    this.searchDietitianPatients(
      this.dietitian.userId.id.toString(),
      this.currentSearchQuery ?? '',
      SortListType.All,
      null,
      this.itemsPerPage,
      page,
      this.dietitian.patientsDefaultSort ?? 'updatedAt',
    )
      .then((pageResult) => {
        this.totalResults = pageResult.totalResults;
        this.currentPage = pageResult.page;
        pageResult.results.forEach((value) => this.patientsList.push(value));
      })
      .catch(() => {
        this.isOnError = true;
      })
      .finally(() => {
        this.isLoading = false;
        this.isAppendLoading = false;
      });
  }

  public searchDietitianPatients(
    dietId: string,
    query: string,
    filterType: SortListType,
    groupId: string | null,
    resultsPerPage: number,
    page: number,
    sort: 'createdAt' | 'updatedAt' | 'lastActiveDate',
  ) {
    return this.patientCommands.searchDietitianPatients(
      dietId,
      query,
      filterType,
      groupId,
      resultsPerPage,
      page,
      sort,
      false,
    );
  }

  public hideModal(): void {
    this.bsModalRef.hide();
  }

  protected readonly SortListType = SortListType;

  async selectPatient(patient: Patient) {
    this.hideModal();
    this.onSelect.emit(
      await this.patientCommands.getPatient(patient.patientId.id.toString()),
    );
  }

  getGroupsLabel(groupIds: string[] | undefined): string[] {
    const labels: string[] = [];
    if (groupIds && groupIds.length > 0 && this.groups) {
      this.groups
        .filter((g) => groupIds.indexOf(g.id.toString()) >= 0)
        .forEach((g) => labels.push(g.name));
    }
    return labels;
  }

  onScroll() {
    this.loadPage(this.currentPage + 1);
  }
}
